// packages/content/src/tuning/index.ts
import { tuningModules } from '../tuning.gen';
export const tuning = tuningModules;
export type Tuning = typeof tuningModules;
